export const LOADING_START = 'LOADING_START';
export const LOADING_FINISH = 'LOADING_FINISH';
export const SHOW_ALERT = 'SHOW_ALERT';
export const CLOSE_ALERT = 'CLOSE_ALERT';
export const SHOW_SELECT_ROLE = 'SHOW_SELECT_ROLE';
export const CLOSE_SELECT_ROLE = 'CLOSE_SELECT_ROLE';
export const SET_IS_MOBILE = 'SET_IS_MOBILE';
export const UPDATE_RESPONSIVE = 'UPDATE_RESPONSIVE';
